import { render, staticRenderFns } from "./sentiment-analysis.vue?vue&type=template&id=4eb54944"
import script from "./sentiment-analysis.vue?vue&type=script&lang=js"
export * from "./sentiment-analysis.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports